import React from 'react'
import { Container } from 'react-bootstrap'

import juntaImg from '../../../assets/img/founders/junta.png'

// Styles
import '../../../styles/quienessomos/founders.styles.scss'
import SubHeading from '../../subHeading/SubHeading';

const boardMembers = [
    {
        name: 'Mª Victoria López Benito',
        role: 'Presidenta',
        bio: 'Doctora en Educación, docente y educadora menstrual. Codirectora del Curso Superior Universitario en Educación Menstrual de la Facultad de Educación de la Universitat de Barcelona (UB).',
    },
    {
        name: 'Carolina Ackermann Barreiro',
        role: 'Secretaria',
        bio: 'Investigadora, educadora, docente, activista y consultora en planes de equidad menstrual y menopausia desde una perspectiva de género, derechos humanos y justicia ecosocial.',
    },
    {
        name: 'Nora Pascual Armendáriz',
        role: 'Tesorera',
        bio: 'Educadora menstrual y docente. Acompaña a centros educativos, ayuntamientos y equipos comunitarios a introducir educación menstrual rigurosa, práctica y con perspectiva de género, para mejorar el bienestar y reducir el estigma en infancia y adolescencia.',
    },
    {
        name: 'Núria Beitia Hernández',
        role: 'Vocal',
        bio: 'Psicóloga y educadora menstrual especializada en salud sexual y cultura menstrual.',
    },
    {
        name: 'Mireia Pérez-Sabadell',
        role: 'Vocal',
        bio: 'Investigadora especializada en comunicación y representación mediática de la menstruación.',
    },
]

const collaboratorMembers = [
    {
        name: 'Mónica Sánchez Gallego',
        bio: 'Psicóloga, terapeuta psicocorporal, especializada en salud cíclica, perinatal, psicofeminismo, trauma, apego y transgeneracional. Madre de dos.',
    },
    {
        name: 'Cristina Triviño de la Cal',
        bio: 'Matrona independiente y educadora menstrual por la UB.',
    },
    {
        name: 'Coral Herranz Lancho',
        bio: "Creadora del proyecto de divulgación sobre salud de la mujer WeAreAllTheSameTribe y de las jornadas artísticas 'Nosotras somos Seres Cíclicas'. Licenciada en Química por la UB y Doctora en Física Química por la Universidad de Estrasburgo (Francia).",
    },
    {
        name: 'Ana Luisa Meza Ferrari',
        bio: 'Psicóloga colegiada en el Col·legi Oficial de Psicologia de Catalunya. Especializada en Danza Movimiento Terapia y psicología perinatal.',
    },
    {
        name: 'Sofía A. Mondragón Miranda',
        bio: 'Psicóloga comunitaria y educadora en salud menstrual y ciclicidad peruana, radicada en Barcelona.',
    },
    {
        name: 'Amanda María López Cobo',
        bio: 'Educadora menstrual especializada en Educación Sexual Integral y proyectos sociocomunitarios.',
    },
]

const Colaborators = () => {

    return (
        <Container fluid className='organization mt-5 pb-5'>
            <SubHeading title='Cómo nos organizamos' color={true} />

            <div className='organization__text p__main'>
                <p>La Vida en Rojo funciona a través de una estructura participativa y horizontal, articulada en torno a la Junta ampliada (presidenta, tesorera, secretaria y vocales) como órgano de decisión. Las vocales colaboradoras trabajan junto a la Junta ampliada, asumiendo cada una la responsabilidad de una comisión de trabajo.</p>
                <p>Estas comisiones vertebran la actividad de la asociación en áreas como la comunicación, la formación, la investigación, las relaciones institucionales o la gestión web, entre otras.</p>
                <p>La asociación cuenta también con amigas colaboradoras (profesionales y entidades afines que, además de contribuir económicamente mediante una cuota, participan activamente en proyectos y activismos) y con amigas donadoras, que sostienen económica y simbólicamente el trabajo de la asociación sin vinculación activa en las actividades.</p>
                <p>Nos regimos por un código ético y un documento de reglamento interno que orientan nuestra forma de trabajar y de relacionarnos. Sabemos que asumir estas responsabilidades es también una forma de cuidado hacia la asociación y hacia todo lo que hemos ido tejiendo juntas a lo largo y ancho desde el año 2019.</p>
            </div>

            <section className='board'>
                <div className='board__photo'>
                    <img src={juntaImg} alt='Junta 2026-2031 de La Vida en Rojo' />
                    <p>Foto: Clara García Ortés</p>
                </div>

                <div className='board__content'>
                    <SubHeading title='Junta 2026-2031' color={true} />
                    <div className='board__members'>
                        {boardMembers.map((member) => (
                            <article className='board__member' key={member.name}>
                                <h3>{member.name}</h3>
                                <span>{member.role}</span>
                                <p>{member.bio}</p>
                            </article>
                        ))}
                    </div>
                </div>
            </section>

            <section className='collaborating-members'>
                <SubHeading title='Vocales colaboradoras' color={true} />
                <div className='collaborating-members__list'>
                    {collaboratorMembers.map((member) => (
                        <article className='collaborator-card' key={member.name}>
                            <h3>{member.name}</h3>
                            <p>{member.bio}</p>
                        </article>
                    ))}
                </div>
            </section>
        </Container>
    )
}

export default Colaborators
